// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1dVL5","delete":"styles_delete__3k63S","update":"styles_update__qcRRj","add":"styles_add__2ptoJ"};